import React from 'react';
import { Check } from 'lucide-react';

interface WizardProgressProps {
  steps: string[];
  currentStep: number;
  title?: string;
}

const WizardProgress: React.FC<WizardProgressProps> = ({ steps, currentStep, title }) => {
  return (
    <div className="w-full py-2">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold">{title || 'Connect Your Google Merchant Center'}</h3>
        <span className="text-xs text-muted-foreground">
          Step {currentStep} of {steps.length}
        </span>
      </div>

      <div className="relative">
        <div className="absolute top-4 left-0 right-0 h-0.5 bg-border" />
        <div
          className="absolute top-4 left-0 h-0.5 bg-primary transition-all duration-500"
          style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
        />

        <div className="relative flex justify-between">
          {steps.map((step, index) => {
            const stepNumber = index + 1;
            const isCompleted = stepNumber < currentStep;
            const isCurrent = stepNumber === currentStep;

            return (
              <div key={step} className="flex flex-col items-center">
                <div
                  className={`
                    w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium
                    transition-all duration-300
                    ${isCompleted ? 'bg-primary text-primary-foreground' : ''}
                    ${isCurrent ? 'bg-primary text-primary-foreground ring-2 ring-primary/20' : ''}
                    ${!isCompleted && !isCurrent ? 'bg-muted text-muted-foreground' : ''}
                  `}
                >
                  {isCompleted ? <Check className="w-4 h-4" /> : stepNumber}
                </div>
                <span className={`
                  mt-1.5 text-[11px] text-center max-w-[80px]
                  ${isCurrent ? 'text-foreground font-medium' : 'text-muted-foreground'}
                `}>
                  {step}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WizardProgress;
